import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../assets/qr-code.json";


const Loader = () => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100vh", justifyContent: "center" }}>
    <Player autoplay loop src={animationData}  speed={0.3}  style={{ height: "150px", width: "150px" }} />
    <p style={{ marginTop: "20px" }}>Cargando sistema...</p>
  </div>
);

export default Loader;
